// @flow

const Intl = require('intl')
require('intl/locale-data/jsonp/en-GB')

export function formatDate(dateTimeInUnix: number): string {
  const date = new Date(dateTimeInUnix)
  return new Intl.DateTimeFormat('en-GB', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  }).format(date)
}
